(function(){

/* ---------- A/B player ---------- */
var ROOT = document.getElementById("vf-reamp");
if(!ROOT){ console.warn("vf-reamp: wrapper div not found on this page"); return; }

var D = ROOT.dataset;

var EX = [
  { label:"Example 1", amp:"5150", sim: D.sim1 || "", vf: D.reamp1 || "" },
  { label:"Example 2", amp:"Marshall JCM800", sim: D.sim2 || "", vf: D.reamp2 || "" }
];
if(!EX[0].sim) console.warn("vf-reamp: no audio urls in data attributes");

var N = 68, bars = document.getElementById("bars"), nodes = [];
for (var i=0;i<N;i++){ var b=document.createElement("i"); bars.appendChild(b); nodes.push(b); }
function seeded(i){ var x = Math.sin(i * 12.9898) * 43758.5453; return x - Math.floor(x); }

function draw(mode){
  var gain = mode === "vf" ? 1 : 0;
  for (var i=0;i<N;i++){
    var dry = seeded(i);
    var thin = 0.18 + 0.72 * Math.pow(dry, 2.6);
    var full = 0.52 + 0.48 * Math.pow(dry, 0.4);
    var v = thin + (full - thin) * gain;
    nodes[i].style.height = (6 + v * 94).toFixed(1) + "%";
  }
  bars.classList.toggle("hot", mode === "vf");
}
draw("sim");

var mode = "sim", playing = false, exIdx = 0;
var bSim = document.getElementById("ab-sim"), bVf = document.getElementById("ab-vf");
var playBtn = document.getElementById("play"), icon = document.getElementById("play-icon");
var note = document.getElementById("rd-note");
var NOTE = note ? note.textContent : "";

/* Web Audio decodes the mp3 into memory, which strips the encoder padding that
   makes an <audio> element click on every loop. Both tracks run off the same
   clock, so the toggle is a gain change and the playhead never moves. */
var AC = null, buffers = {}, srcs = {}, gains = {}, loading = false;

function ctx(){
  if(!AC){
    var C = window.AudioContext || window.webkitAudioContext;
    if(!C) return null;
    AC = new C();
  }
  return AC;
}

function decode(ab){
  var c = ctx();
  return new Promise(function(res, rej){
    var p = c.decodeAudioData(ab, res, rej);
    if(p && p.then) p.then(res, rej);
  });
}

function fetchPair(i){
  var e = EX[i];
  return Promise.all([e.sim, e.vf].map(function(u){
    return fetch(u).then(function(r){ return r.arrayBuffer(); }).then(decode);
  })).then(function(bufs){
    buffers[i] = { sim: bufs[0], vf: bufs[1] };
    return buffers[i];
  });
}

function stopNodes(){
  ["sim","vf"].forEach(function(k){
    if(srcs[k]){ try{ srcs[k].stop(); }catch(e){} srcs[k].disconnect(); srcs[k] = null; }
  });
}

function startPair(pair){
  var c = ctx();
  stopNodes();
  var t = c.currentTime + 0.05;
  ["sim","vf"].forEach(function(k){
    var s = c.createBufferSource();
    s.buffer = pair[k];
    s.loop = true;                 /* sample accurate, no gap */
    var g = c.createGain();
    g.gain.value = (mode === k) ? 1 : 0;
    s.connect(g); g.connect(c.destination);
    s.start(t);
    srcs[k] = s; gains[k] = g;
  });
}

function setNote(t){ if(note) note.textContent = t; }

function applyMode(){
  bSim.setAttribute("aria-pressed", mode === "sim" ? "true" : "false");
  bVf.setAttribute("aria-pressed",  mode === "vf" ? "true" : "false");
  draw(mode);
  if(gains.sim && gains.vf){
    var c = ctx(), t = c.currentTime;
    /* 15ms ramp: inaudible as a fade, but stops the click a hard cut makes */
    ["sim","vf"].forEach(function(k){
      gains[k].gain.cancelScheduledValues(t);
      gains[k].gain.setValueAtTime(gains[k].gain.value, t);
      gains[k].gain.linearRampToValueAtTime(mode === k ? 1 : 0, t + 0.015);
    });
  }
}

function labels(){
  var n = exIdx + 1;
  var amp = EX[exIdx].amp ? " (" + EX[exIdx].amp + ")" : "";
  var a = document.getElementById("ab-l-sim"), c = document.getElementById("ab-l-vf");
  if(a) a.textContent = "Amp Sim #" + n + amp;
  if(c) c.textContent = "VF Reamp #" + n + amp;
}

function setIcon(p){
  icon.innerHTML = p
    ? '<rect x="7" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/>'
    : '<path d="M8 5 L19 12 L8 19 Z" fill="currentColor"/>';
  playBtn.setAttribute("aria-label", p ? "Pause" : "Play");
}

function play(){
  if(loading) return;
  var c = ctx();
  if(!c){ setNote("Audio not supported in this browser"); return; }
  if(c.state === "suspended") c.resume();

  if(buffers[exIdx]){ startPair(buffers[exIdx]); playing = true; setIcon(true); return; }

  loading = true; setNote("Loading...");
  fetchPair(exIdx).then(function(pair){
    loading = false; setNote(NOTE);
    startPair(pair); playing = true; setIcon(true);
  }).catch(function(err){
    loading = false; setNote("Could not load audio");
    console.warn("vf-reamp audio:", err);
  });
}

function pause(){
  stopNodes(); playing = false; setIcon(false);
}

bSim.addEventListener("click", function(){ mode = "sim"; applyMode(); });
bVf.addEventListener("click",  function(){ mode = "vf"; applyMode(); });

document.querySelectorAll(".ex-b").forEach(function(btn){
  btn.addEventListener("click", function(){
    var i = +btn.dataset.ex;
    if(i === exIdx) return;
    exIdx = i;
    document.querySelectorAll(".ex-b").forEach(function(o){
      o.setAttribute("aria-pressed", o === btn ? "true" : "false");
    });
    labels();
    var wasPlaying = playing;
    pause();
    if(wasPlaying) play();
  });
});

playBtn.addEventListener("click", function(){ playing ? pause() : play(); });

labels();

/* ---------- native Shopify form ---------- */
/* Shopify posts the form and reloads the page. When it comes back successful,
   jump straight to the confirmation. */
function showConfirmation(){
  var out = document.querySelector('[data-step="out"]');
  if(out) out.hidden = false;
  var p1 = document.getElementById("pane1"), p3 = document.getElementById("pane3");
  if(p1) p1.hidden = true;
  if(p3){ p3.hidden = false; p3.scrollIntoView({block:"center"}); }
}

if(document.getElementById("vf-posted")) showConfirmation();

/* ---------- signal chain builder ---------- */
(function(){
  var root = document.getElementById("builder");
  if(!root) return;

  /* skipAll: any "Just pick it for me" button ends the questions and drops
     the visitor straight into the form. The form already asks for reference
     songs, which tells us more than the genre buttons would. */
  var state = {amp:null, ampKind:null, cab:null, cabPick:false, mics:[], micPick:false, sound:null, skipAll:false, skipFrom:null};

  function step(n){ return root.querySelector('[data-step="'+n+'"]'); }
  function show(n,v){ step(n).hidden = !v; }

  function needsSound(){
    return state.ampKind === "pick" || state.micPick || state.cabPick;
  }

  function summarise(){
    var parts = [];
    parts.push("Amp: <b>" + (state.ampKind === "pick" ? "your call" : state.amp) + "</b>");
    if(state.ampKind === "head") parts.push("Cab: <b>" + (state.cab || "your call") + "</b>");
    var micText = (state.micPick || state.mics.length === 0) ? "your call" : state.mics.join(", ");
    parts.push("Mics: <b>" + micText + "</b>");
    if(state.sound) parts.push("Sound: <b>" + state.sound + "</b>");

    document.getElementById("build-sum").innerHTML = parts.join("<br>");
    window.__chain = parts.join(" / ").replace(/<[^>]+>/g, "");
    var hidden = document.getElementById("f-chain");
    if(hidden) hidden.value = window.__chain;
  }

  function jumpToForm(){
    var out = step("out");
    if(out) out.scrollIntoView({behavior:"smooth", block:"start"});
  }

  function render(){
    /* short circuit: they asked us to choose, so stop asking */
    if(state.skipAll){
      show("cab", false);
      show("mic", false);
      show("sound", false);
      show("out", true);
      summarise();
      var fn = document.getElementById("final-n");
      if(fn){
        var n = state.skipFrom === "amp" ? "02" : (state.skipFrom === "cab" ? "03" : (state.ampKind === "head" ? "04" : "03"));
        fn.textContent = n;
      }
      return;
    }

    show("cab", state.ampKind === "head");
    if(state.ampKind !== "head"){ state.cab = null; state.cabPick = false; }

    show("mic", !!state.amp && (state.ampKind !== "head" || !!state.cab));
    show("sound", needsSound() && !!state.amp);

    var micsDone = state.micPick || state.mics.length > 0;
    var chainDone = !!state.amp
      && (state.ampKind !== "head" || !!state.cab)
      && micsDone
      && (!needsSound() || !!state.sound);
    show("out", chainDone);

    var c = document.getElementById("mic-count");
    if(c) c.textContent = state.micPick ? "we choose" : state.mics.length + " of 3 selected";

    if(chainDone){
      summarise();
      var fn = document.getElementById("final-n");
      if(fn) fn.textContent = needsSound() ? "05" : "04";
    }
  }

  /* amp */
  step("amp").addEventListener("click", function(e){
    var b = e.target.closest(".opt"); if(!b) return;
    var was = b.getAttribute("aria-pressed") === "true";
    step("amp").querySelectorAll(".opt").forEach(function(o){ o.setAttribute("aria-pressed","false"); });

    if(was){
      state.amp = null; state.ampKind = null;
      state.skipAll = false; state.skipFrom = null;
      render(); return;
    }

    b.setAttribute("aria-pressed","true");
    state.amp = b.dataset.name;
    state.ampKind = b.dataset.kind;

    if(state.ampKind === "pick"){
      state.skipAll = true; state.skipFrom = "amp";
      state.cab = null; state.cabPick = false;
      state.mics = []; state.micPick = true;
      state.sound = null;
      render(); jumpToForm(); return;
    }

    state.skipAll = false; state.skipFrom = null;
    render();
  });

  /* cab */
  step("cab").addEventListener("click", function(e){
    var b = e.target.closest(".opt"); if(!b) return;
    var was = b.getAttribute("aria-pressed") === "true";
    step("cab").querySelectorAll(".opt").forEach(function(o){ o.setAttribute("aria-pressed","false"); });

    if(was){
      state.cab = null; state.cabPick = false;
      state.skipAll = false; state.skipFrom = null;
      render(); return;
    }

    b.setAttribute("aria-pressed","true");
    state.cabPick = !!b.dataset.pickcab;
    state.cab = state.cabPick ? "your call" : b.dataset.name;

    if(state.cabPick){
      state.skipAll = true; state.skipFrom = "cab";
      state.mics = []; state.micPick = true;
      state.sound = null;
      render(); jumpToForm(); return;
    }

    state.skipAll = false; state.skipFrom = null;
    render();
  });

  /* mics: up to 3, or hand it to us */
  step("mic").addEventListener("click", function(e){
    var b = e.target.closest(".opt"); if(!b) return;
    var on = b.getAttribute("aria-pressed") === "true";

    if(b.dataset.pick){
      state.micPick = !on;
      b.setAttribute("aria-pressed", state.micPick ? "true" : "false");
      if(state.micPick){
        state.mics = [];
        step("mic").querySelectorAll(".opt:not([data-pick])").forEach(function(o){ o.setAttribute("aria-pressed","false"); });
        state.skipAll = true; state.skipFrom = "mic";
        state.sound = null;
        render(); jumpToForm(); return;
      }
      state.skipAll = false; state.skipFrom = null;
      render(); return;
    }

    if(on){
      b.setAttribute("aria-pressed","false");
      state.mics = state.mics.filter(function(m){ return m !== b.dataset.name; });
    } else {
      if(state.mics.length >= 3) return;
      b.setAttribute("aria-pressed","true");
      state.mics.push(b.dataset.name);
      if(state.micPick){
        state.micPick = false;
        step("mic").querySelector("[data-pick]").setAttribute("aria-pressed","false");
      }
    }
    state.skipAll = false; state.skipFrom = null;
    render();
  });

  /* sound */
  step("sound").addEventListener("click", function(e){
    var b = e.target.closest(".opt"); if(!b) return;
    var was = b.getAttribute("aria-pressed") === "true";
    step("sound").querySelectorAll(".opt").forEach(function(o){ o.setAttribute("aria-pressed","false"); });
    if(was){ state.sound = null; }
    else { b.setAttribute("aria-pressed","true"); state.sound = b.dataset.name; }
    render();
  });

})();

/* ---------- scroll reveal ---------- */
if ("IntersectionObserver" in window){
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
  },{threshold:.12});
  document.querySelectorAll(".rise").forEach(function(el){ io.observe(el); });
} else {
  document.querySelectorAll(".rise").forEach(function(el){ el.classList.add("in"); });
}

})();